import { atom } from "recoil";
export const UserImageState = atom({
    key: "UserImageState", // unique ID (with respect to other atoms/selectors)
    default: `${process.env.REACT_APP_BASE_URL_API}/media/uploads/users/default.png`, // default value (aka initial value)
});
